<template>
  <div class="addCustomer">
    <div class="customer_total_tab">
      <van-tabs class="tab_customer" v-model="activeName" @change="onClickTab">
        <van-tab name="" title="全部"></van-tab>
        <van-tab :name="0">
          <template #title>
            <span>待添加{{'('+toAdd+')'}}</span>
          </template>
        </van-tab>
        <van-tab :name="1">
          <template #title>
            <span>待通过{{'('+toPass+')'}}</span>
          </template>
        </van-tab>
        <van-tab :name="2" title="已添加"></van-tab>
      </van-tabs>

    </div>
    <div class="tab_component_wrap">
       <p class="header_title" v-show="list.length>0">请复制手机号添加客户</p>
      <input type="text" ref="textarea" style="display: none" />
       <div class="customer_list_wrap">
         <van-list
             v-model="loading"
             :finished="finished"
             loading-text="正在加载中..."
             finished-text="暂无更多内容了"
             :immediate-check="false"
             @load="load_more"
         >
          <div class="customer_item" v-for="item in list" :key="item.id">
             <div class="customer_item_left">
               <p>{{item.name}}</p>
               <span>{{item.phone}}</span>
             </div>
             <div class="customer_item_right">
               <p v-if="item.status===0">待添加</p>
               <p v-else-if="item.status===1">待通过</p>
               <p v-else-if="item.status===2">已通过</p>
               <span v-if="item.status===0 || item.status===1" @click="copyTel(item)">复制号码</span>
             </div>
          </div>
         </van-list>
       </div>
    </div>
  </div>
</template>

<script>
import { wecustomerpotentialOverview,
  wecustomerpotentialList,
  wecustomerpotentialCopy,
} from '@/server/api';
import { addressBar } from "@/utils/public";
import {Toast} from 'vant';
export default {
  name: "addCustomer",
  data(){
    return {
      activeName:'',
      toAdd:0,
      toPass:0,
      loading:false,
      finished:false,
      pageNum:1,
      pageSize:20,
      status:'',
      list:[],
      userId:localStorage.getItem('userid')
    }
  },
  watch: {
    // "$store.state.tokenFlag": function (newval) {
    //   if (newval) {
    //     this.totalCurrent();
    //     this.getCustomerList();
    //   }
    // },
  },
  mounted() {
    let windowurl =
        window.location.href.split("#")[0] || "http://tm-qw.1000phone.net/addCustomer";
    if (localStorage.getItem("token")) {
      this.userId = localStorage.getItem('userid');
      this.totalCurrent();
      this.getCustomerList();
    } else {
      addressBar("token", windowurl);
    }
  },
  methods:{
    onClickTab(data){
      this.list = [];
      this.pageNum = 1;
      this.status = data;
      this.getCustomerList();
    },
    load_more(){
      this.pageNum++;
      this.getCustomerList();
    },

    async copyTel(value){
      if (value == null || value === '') return false;
      const textarea = document.createElement('textarea');
      textarea.value = value.phone;
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.setSelectionRange ? textarea.setSelectionRange(0, textarea.value.length) : textarea.select();
      await document.execCommand('copy');
      document.body.removeChild(textarea);
      this.$toast({position:"bottom",message:'复制成功',type:'success'});
      if(!this.status) await this.clickCopyTel(value);
    },

    async clickCopyTel(val){
      this.loading = true;
      const res = await wecustomerpotentialCopy({
         id:val.id,
         phone:val.phone,
      });
      this.loading = false;
      if(res.code !=='200') return Toast.fail(res.msg);
      await this.totalCurrent();
      this.list = [];
      this.pageNum = 1;
      await this.getCustomerList();
    },

    async getCustomerList(){
      this.loading = true;
      const res = await wecustomerpotentialList({
        pageNum:this.pageNum,
        pageSize:this.pageSize,
        status:this.status,
        userId:this.userId
      });
      this.loading = false;
      if (res.code !== "200") return Toast.fail(res.msg);
      this.list = this.list.concat(res.data.list);
      if (res.data.list.length == 0 || res.data.list.length < this.pageSize) {
        //数据全部加载完成
        this.finished = true;
      } else {
        this.finished = false;
      }
    },

    async totalCurrent(){
      const res = await wecustomerpotentialOverview({
        userId: this.userId
      });
      if(res.code!=='200') return Toast.fail(res.msg);
      this.toAdd = res.data.toAdd;
      this.toPass = res.data.toPass;
    },
  },
}
</script>

<style scoped lang="less">
.addCustomer{
  .customer_total_tab {
    background-color: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    .tab_customer {
      /deep/.van-tabs__wrap {
        height: 80px;
      }
      /deep/.van-tabs__nav--line {
        //padding-bottom: 30px;
      }
      /deep/.van-tabs__line {
        width: 50px;
        height: 6px;
        background: linear-gradient(90deg, #4fb6ff 0%, #277fff 100%);
        border-radius: 3px;
      }
      /deep/.van-tab {
        height: 80px;
        line-height: 80px;
        color: #666666;
        font-size: 28px;
      }
      /deep/.van-tab--active {
        font-weight: 600;
        color: #333333 !important;
      }
    }
  }
  .tab_component_wrap{
    padding: 95px 30px 16px;
    .header_title{
      font-size: 24px;
      color: #999999;
    }
    .customer_list_wrap{
      padding-top: 14px;
      .customer_item{
        border-radius: 10px;
        padding: 20px;
        margin-bottom: 16px;
        background-color: #ffffff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .customer_item_left{
          p{
            font-size: 28px;
            color: #333333;
            margin-bottom: 10px;
          }
          span{
            font-size: 24px;
            color: #666666;
          }
        }
        .customer_item_right{
          display: flex;
          flex-direction: column;
          justify-content: center;
          p{
            font-size: 22px;
            color: #C2C2C2;
            text-align: right;
            margin-bottom: 10px;
          }
          span{
            display: inline-block;
            color: #277FFF;
            font-size: 24px;
            padding: 6px 16px;
            border-radius: 23px;
            background-color: #DFECFF;
          }
        }
      }
    }
  }
}
</style>
